import { render, staticRenderFns } from "./PromiseButton.vue?vue&type=template&id=ef1a56c8&"
import script from "./PromiseButton.vue?vue&type=script&lang=js&"
export * from "./PromiseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports